import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-check-steps-dialog',
  templateUrl: './check-steps-dialog.component.html',
  standalone: false,
})
export class CheckStepsDialogComponent {
  stepIdx: number | undefined;
  leadId: string | undefined;
  allTasksComplete: boolean = false;

  steps: any = [];

  constructor(
    public dialogRef: MatDialogRef<CheckStepsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      leadId: string;
      stepIdx: number;
    },
  ) {
    this.leadId = data.leadId;
    this.stepIdx = data.stepIdx;
  }

  ngOnInit() {
    switch (this.stepIdx) {
      case 0:
        this.steps = [
          { id: '0.0', text: 'Call scheduled' },
          { id: '0.1', text: 'Call complete' },
        ];
        break;
      case 1:
        this.steps = [
          { id: '1.0', text: 'Call scheduled' },
          { id: '1.0', text: 'Call complete' },
        ];
        break;
      case 2:
        this.steps = [{ id: '2.0', text: 'Analyzed recent statements' }];
        break;
      case 3:
        this.steps = [
          { id: '3.0', text: 'Proposal document uploaded' },
          { id: '3.1', text: 'Call scheduled' },
          { id: '3.2', text: 'Call completed' },
        ];
        break;
      case 4:
        this.steps = [
          { id: '4.0', text: 'Application sent' },
          { id: '4.1', text: 'Application signed' },
        ];
        break;
      // case 5:
      //   this.steps = [{id:"5.0", text:"Application sent"}, {id:"5.1", text:"Application signed"}]
      //   break;
    }
  }

  ngAfterViewInit() {
    this._checkTasks();
  }

  handleCheck_click(stepIdx: any) {
    this._checkTasks();
  }

  handleComplete_click() {
    this._checkTasks();
    this.dialogRef.close(this.allTasksComplete);
  }

  handleClose_click() {
    this.dialogRef.close(this.allTasksComplete);
  }

  _checkTasks() {
    let chks = document.getElementById('tasks')?.getElementsByTagName('input');

    let allComplete = true;

    if (chks) {
      for (var i = 0; i < chks.length; i++) {
        if (chks[i].type === 'checkbox') {
          if (!chks[i].checked) {
            allComplete = false;
          }
        }
      }
    }

    this.allTasksComplete = allComplete;
  }
}
